import React from 'react';
import LAppOnline from '../../../app/layouts/LAppOnline';
import TestUi from '../features/ui/TestUi';

const PTestUi = () => {
	return (
		<LAppOnline>
			<TestUi />
		</LAppOnline>
	);
};

export default PTestUi;
